var $ = global.jQuery
    , ko                  = require('knockout')
    , core                = require('CoreModule')
    , events              = core.Events
    , controllerEvents    = require('ControllerEvents.js')
    , helpers             = core.Helpers
    , moment              = core.Moment

    var swatches = {
        /*
          TargetName : 'Maroon'
        , Cycle      : 'Navy'
        , Itemname   : 'SaddleBrown'
        , ActualStart: 'DarkCyan'
        , CallId     : 'DarkOliveGreen'
        , PostCode   : 'Indigo'
        , Town       : 'DarkSlateGray'
        , Brand      : 'DarkGoldenrod'
        */
    }


ko.bindingHandlers.thumbnail = {

    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        // This will be called when the binding is first applied to an element
        // Set up any initial state, event handlers, etc. here

        var item = valueAccessor();

        var statusObj = helpers.getStatusObjFromItem(item);

        item.statusObservable = ko.observable(statusObj && statusObj.Value)
        item.statusCSS        = ko.pureComputed(function () {
            var status = item.statusObservable();
            return (status && status!=='Default') ? 'glyphicon ' + (status==='Approved'?'glyphicon-ok':'glyphicon-remove') : '';
        });
            

        item.mouseOverLeft  = ko.observable();
        item.mouseOverRight = ko.observable();
        item.swatches       = swatches;

        $(element).hover(function(a,b,c){
           // $(this).filter(':not(:animated)').animate({ width: "200px" });

           var $element = $(element), width = $element.width(), height = $element.height(), offset = $element.offset(), 
               leftCheck = 0.34 * width, rightCheck = 0.66 * width


           $(element).on( "mousemove", function(e){ 
                
                var xPos = e.pageX - offset.left, yPos = e.pageY - offset.top;

                item.mouseOverLeft (xPos < leftCheck );
                item.mouseOverRight(xPos > rightCheck);
           });

        }, function() {

            $(element).off( "mousemove" );
           // $(this).animate({ width: "100px" });
           item.mouseOverLeft(false);
           item.mouseOverRight(false);


        });

    }

};

var PictureGridViewModel = function (init) {

    var self = this;

    global.pictureGridViewModel = self;

    console.log('PictureGridViewModel', self, init);


    self.InterControllerEmitter = init.InterControllerEmitter;
    self.helpers = helpers;

    self.picturePage = ko.observableArray();
    self.busy = ko.observable();

    var pswp      = null;
    var resizeHandler = helpers.makeVerticalDistribute([$('#topPanel'),$('#bottomPanel')], $('#middleSection'));

    self.IsPublicMapViewEnabled = ko.observable();
    self.mapsLock         = ko.observable();
    self.count            = ko.observable();
    self.QueryResultCount = ko.observable();
    self.CurrentPage      = ko.observable(1);
    self.PageSize         = ko.observable(1);
    self.TotalPages       = ko.observable(1);
    self.HighlightedPhoto = ko.observable();
    self.GalleryDetails   = ko.observable(init.GalleryDetails);
    self.ViewOption       = ko.observable("Query Results");
    self.viewOptions      = { QueryResults: "Query Results", SelectedItems: "Selected Photos"  }

    self.setViewOption    = function (option) {
        
        self.ViewOption(option).busy(true);
        getGalleryDataPage(1);
        events.emitter.emit(events.gallery_view_option_change, self.ViewOption(), self.viewOptions);
    }

    self.template = ko.pureComputed(function () {
        return { name: (_.some(self.picturePage()) || self.ViewOption() === self.viewOptions.SelectedItems ?'pictureGrid':'galleryLogo') + 'Template' }
    })

    self.refresh = function () {
        
        getGalleryDataPage(self.CurrentPage());
            
    }

    self.count.subscribe(function (newCount) {
        
    })

    self.showReset = ko.pureComputed(function () {
        return !self.busy() && self.ViewOption() === self.viewOptions.SelectedItems && self.count() !== self.picturePage().length;
    })

    self.hideReset = ko.pureComputed(function () {
        return self.busy() || self.ViewOption() !== self.viewOptions.SelectedItems || self.count() === self.picturePage().length;
    })
    
    ko.bindingHandlers.fadeIn = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                $(element).addClass('faded');
        },
        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var $element = $(element);
            $element.removeClass('faded');
            ko.unwrap(valueAccessor()) ? $element.addClass('fadeIn' ).removeClass('fadeOut')
                                       : $element.addClass('fadeOut').removeClass('fadeIn' )
        }
    };

    var setTileSelection = function(tile, selectionState){
        tile.SelectionState(!!selectionState);
        tile.Selected = selectionState;
    }

    self.goToSplashScreen = function(){
        events.emitter.emit(events.gallery_splash_selected);
    }

    self.logOut = function(){

        console.log('picture grid view logout');

        events.emitter.emit(events.log_out);
        //self.InterControllerEmitter.emit(events.log_out);
    }

    var selectPage = function(selectState, noevent){

        var tiles = _.filter(self.picturePage(), { Selected : (1 - selectState) } ), pictureIds = _.map(tiles, 'PictureId');
        console.error((selectState?'de-':'') + 'select all pictures on page', pictureIds);
        noevent || events.emitter.emit(events.set_picture_selection_state, { select_list: pictureIds, Selected: selectState });
        noevent || self.count(self.count() + pictureIds.length * (selectState ? 1 : -1));
        _.each(tiles, function(tile){ setTileSelection(tile, selectState) } );
    }
    , setHighlightedPhoto  = function($index){ 
        
        self.HighlightedPhoto(self.picturePage()[$index])
    }

    self.modalVisible   = ko.observable();
    self.pictureDetailVisible   = ko.observable();
    self.clickShowModal = function () { self.modalVisible(true) }
    self.selectPageAll  = function(){ selectPage(1) }
    self.selectPageNone = function(){ selectPage(0) }

    self.unselectAll    = function(){ selectPage(0, true);
         self.count(0);
         self.modalVisible(false);
         events.emitter.emit(events.set_picture_selection_state, { unselect_all: true })
    }

    self.downloadOptions = _.map(['Zip','Powerpoint','Word'], function(option){
        return {
              Option     : option
            , downloading: ko.observable()
        }
    }); 
    
    var _statusChangeOptions = 
    [
        {
            Option      : 'Publish'
          , Status      : 'Approved'
          , css         : 'glyphicon glyphicon-ok'
          , mode        : true
        },
        {
            Option      : 'Unpublish'
          , Status      : 'Default'
          , css         : 'glyphicon glyphicon-minus'
          , mode        : true
        },
        {
            Option      : 'Reject'
          , Status      : 'Rejected'
          , css         : 'glyphicon glyphicon-remove'
          , mode        : false
        },        
        {
            Option      : 'Accept'
          , Status      : 'Default'
          , css         : 'glyphicon glyphicon-minus'
          , mode        : false
        }

    ];

    self.IsPictureApprovalModeEnabled = ko.observable(init.GalleryDetails2.IsPictureApprovalModeEnabled);

    self.statusChangeOptions = ko.pureComputed(function(){

        return _.filter(_statusChangeOptions, { mode: self.IsPictureApprovalModeEnabled() } );
        
    });


    self.downloading      = ko.observable();
    self.btnsEnabled      = ko.pureComputed(function () { return self.count() && !self.downloading() })
    self.downloadBtnClass = ko.pureComputed(function () { return self.btnsEnabled() ? 'btn-default btn-outline-secondary' : 'btn-outline-secondary outline-secondary-disabled' })
    self.requestDownload  = function (option) {
              
        console.error('OK Google - download my pictures!', option);
        events.emitter.emit(events.request_bulk_picture_download, option);
        option.downloading(true);
        self.downloading(option);
    }
    self.requestUpdate  = function (option) {
                
        console.error('OK Google - update my pictures!', option);
        events.emitter.emit(events.request_bulk_picture_update, option);
        option.downloading(true);
        self.downloading(option);
    }    
    var onDownloaded = function (option) {

        self.downloading() && self.downloading().downloading(false);
        self.downloading(false);
    }

    var onStatusChanged = function (update) {
        
        console.log('picture grid view - on StatusChanged ', update, self.picturePage);

        var message = _.some(update.PictureIds)

        ? _(self.picturePage()).keyBy('PictureId').at(update.PictureIds).compact().each(helpers.setStatus(update.ApprovalStatus))
            && _.join(['Updated',_.size(update.PictureIds),'successfully.'],' ')
            
        : 'No Pictures need updating';

        events.emitter.emit(events.info, message);

        setTimeout(events.makeTrigger(events.info, false), 15000);

        onDownloaded();
    } 


    self.PaginationControlParameters = { CurrentPage: self.CurrentPage, PageSize: self.PageSize, TotalPages: self.TotalPages }

    events.emitter.on(events.resize         , resizeHandler   );
    events.emitter.on(events.file_downloaded, onDownloaded    );
    events.emitter.on(events.status_changed , onStatusChanged );

    var titleTextFromMetaData = function (nthPicture) {
        var titleText = '';
        _.each(nthPicture.FileNameFields, function(nthField){
            var nthTitlePart = _.find(nthPicture.MetaData, function (nthProperty) { return nthProperty.Property === nthField.FieldName })
            if (nthTitlePart && nthTitlePart.Value){
                titleText = titleText + nthTitlePart.Value + ' '; 
            }

        })
        if (titleText.length === 0){
            titleText = nthPicture.PictureId;
        }
        return titleText;
    }
    
    , infoDisplayFieldsFromMetaData = function (nthPicture) {
        var infoDisplayFields = []
        _.each(nthPicture.DisplayFields, function(nthField){
            switch(nthField.FieldName.toLowerCase())
            {
                case 'timestamp':
                    var nthDisplayProperty = { Property: 'TimeStamp', Value: nthPicture.TimeStamp };
                    break;

                case 'latitude':
                    var nthDisplayProperty = { Property: 'Latitude', Value: nthPicture.Latitude };
                    break;

                case 'longitude':
                    var nthDisplayProperty = { Property: 'Longitude', Value: nthPicture.Longitude };
                    break;
                    
                case 'imagesource':
                    var nthDisplayProperty = { Property: 'ImageSource', Value: nthPicture.ImageSource };
                    break;

                default:
                    var nthDisplayProperty = _.find(nthPicture.MetaData, { Property : nthField.FieldName })
            }

            if (nthDisplayProperty && nthDisplayProperty.Value && nthDisplayProperty.Value.length > 0){
               nthDisplayProperty.Value = _.replace(_.trim(nthDisplayProperty.Value,"|"),new RegExp(_.escapeRegExp ("|"),"g"),", ");
               
                _.assign(nthDisplayProperty,{'Label':nthField.FieldLabel })
                    infoDisplayFields.push(nthDisplayProperty);
            }
        })
        if (infoDisplayFields.length === 0){
            infoDisplayFields.push({Property: 'PictureID',Value: nthPicture.PictureId})
        }
        return infoDisplayFields;
    }
    
    , modelFromMetaData = function (nthPicture) {
            

        var model = _.clone(nthPicture);

        return _.assign(model, {
              Selected             : model.Selected
            , SelectionState       : ko.observable(model.Selected === 1)
            , events               : events
            , SelectionChange      : function (context) {
                                         console.log(context);
                                         setTileSelection (context, 1 - context.Selected);
                                         self.count(self.count() + (context.Selected ? 1 : -1));
                                         events.emitter.emit(events.set_picture_selection_state, _.assign(nthPicture, { Selected: context.Selected } ));
                                     }
            , infoVisible          : ko.observable()
            , toggleInfoVisibility : function(){
                                        console.log(model);
                                        model.infoVisible(!model.infoVisible())  
                                     }
            , Title                : titleTextFromMetaData(model)
            , InfoDisplayFields    : infoDisplayFieldsFromMetaData(model)

        })

    }

    self.InterControllerEmitter.on(controllerEvents.gallery_page_data_loaded, function (pictureMetaData) {

        events.emitter.emit(events.layout_change);

        console.error('Gallery Filters Loaded', pictureMetaData);
        var model = _.map(pictureMetaData.MetaData, modelFromMetaData);

        self.picturePage(model);
        self.CurrentPage(pictureMetaData.CurrentPage);
        self.PageSize(pictureMetaData.PageSize);
        var totalPages = _.ceil((self.ViewOption() === "Query Results" ? pictureMetaData.Overview.ResultCount : self.count()) / pictureMetaData.PageSize);
        self.TotalPages(totalPages);
        self.QueryResultCount(pictureMetaData.Overview.ResultCount);
        self.IsPublicMapViewEnabled(pictureMetaData.Overview.IsPublicMapViewEnabled);

        setUpPhotoSwipe();

        self.busy(false);
    });

    // Set up click event for pictures, to raise the embiggen dialogue:
    var setUpPhotoSwipe = function () {
        $('.picture').off('click', 'figure');

        $('.picture').each(function () {
            var $pic   = $(this);

            $pic.on('click', 'figure', function (event) {
                event.preventDefault();

                var currentTile = $(this).find(event.target).closest(".tile")
                 ,  container   = $(currentTile).parent()
                 ,  $index      = $(container).find(".tile").index( currentTile )

                pictureGridViewModel.pictureDetailVisible(true);
                setHighlightedPhoto($index);

                // Prevent race conditions between the Modal and Slider:
                var attempts = 0;

                var tid = setInterval(function(){
                    if ($("#testmodalblah").is(":visible") == false && attempts < 10){
                        attempts++;
                    } else {
                        // Anything dependent on the slider should be in here:

                        clearInterval(tid);
                        $(".slider").slick();
                        $(".slider").slick("slickGoTo", $index, true);

                        if (pictureGridViewModel.IsPublicMapViewEnabled() == true) {
                            // "MapsLock" functionality:
                            $('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide){                                            
                                if (pictureGridViewModel.mapsLock() == true && !($("#photo_" + currentSlide).is(":hidden"))) {
                                    var thisPicture = pictureGridViewModel.picturePage()[currentSlide];
                                    pictureGridViewModel.toggleMap(currentSlide, thisPicture.TimeStamp, thisPicture.Latitude, thisPicture.Longitude);
                                }
                            });

                            // Prevent dragging the map from swiping the slide:
                            $(function() {
                                $('*[draggable!=true]','.slick-track').unbind('dragstart');
                                //$( ".mapContainer" ).draggable();
                            });
                            
                            $(".mapContainer").on("draggable mouseenter mousedown",function(event){
                                event.stopPropagation();
                            });

                            if (pictureGridViewModel.mapsLock() == true){                            
                                var thisPicture = pictureGridViewModel.picturePage()[$index];
                                pictureGridViewModel.toggleMap($index, thisPicture.TimeStamp, thisPicture.Latitude, thisPicture.Longitude);
                            }
                        } else {
                            pictureGridViewModel.mapsLock(false);
                        }
                    }
                  }, 100); 
            });
        });
    }

    // Toggle between the picture and map on a given slide. Initialises the map lazily.
    self.toggleMap = function (pictureIndex, timestamp, latitude, longitude) {
        if ($("#photo_" + pictureIndex).is(":hidden") || pictureGridViewModel.IsPublicMapViewEnabled() == false) {
            $("#photo_" + pictureIndex).show();
            $("#map_" + pictureIndex).hide();
        }
        else {
            $("#photo_" + pictureIndex).hide();
            $("#map_" + pictureIndex).show();

            if ((latitude && longitude && (latitude != 0 || longitude != 0))) {
                try {
                    if (pictureGridViewModel["map_" + pictureIndex] != undefined) {
                        pictureGridViewModel["map_" + pictureIndex].remove();
                    }

                    pictureGridViewModel["map_" + pictureIndex] = L.map("map_" + pictureIndex, {
                        attributionControl: false
                      }).setView([latitude, longitude], 13);

                    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                        attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
                    }).addTo(pictureGridViewModel["map_" + pictureIndex]);

                    L.control.attribution({
                        position: 'bottomright'
                      }).addTo(pictureGridViewModel["map_" + pictureIndex]);
                    
                    var formattedTimestamp = moment(timestamp).format("DD/MM/YYYY HH:mm");

                    L.marker([latitude, longitude]).addTo(pictureGridViewModel["map_" + pictureIndex])
                        .bindPopup(formattedTimestamp + " at <br/>" + latitude + ", " + longitude).openPopup();
                }
                catch (err) {
                    console.error(err.message);
                    $("#map_" + pictureIndex).html("<b>There was a problem displaying the map.</b>");
                }
            } else {
                $("#map_" + pictureIndex).html("<b>Coordinates are not available for this picture.<b>");
            }
        } 
    }

    // When mapsLock is true, slides will toggle to the map on navigation. When false, nothing will happen.
    self.toggleMapsLock = function (pictureIndex, timestamp, latitude, longitude) {
        if ((pictureGridViewModel.mapsLock() == undefined || pictureGridViewModel.mapsLock() == false)
            && pictureGridViewModel.IsPublicMapViewEnabled() == true) {
            pictureGridViewModel.mapsLock(true);

            if (!($("#photo_" + pictureIndex).is(":hidden"))) {
                pictureGridViewModel.toggleMap(pictureIndex, timestamp, latitude, longitude);
            }
        } else {
            pictureGridViewModel.mapsLock(false);

            if ($("#photo_" + pictureIndex).is(":hidden")) {
                $("#photo_" + pictureIndex).show();
                $("#map_" + pictureIndex).hide();
            }
        }
    }

    var getGalleryDataPage = function (pageNumber) {
        console.warn("Page Change.....Page", pageNumber)
        var pageInfo = { PageNumber: pageNumber, PageSize: 15, Option: self.ViewOption() }
        events.emitter.emit(events.get_gallery_data_page, pageInfo);
    }

    events.emitter.on(events.pagination_page_change, function (pageNumber) {
        getGalleryDataPage(pageNumber);
    })

    events.emitter.on(events.selection_count, self.count); 

    self.InterControllerEmitter.on(controllerEvents.gallery_details_loaded, self.GalleryDetails);

    var onInitFirst = (function(){
        console.log('PictureGridView', self);
        events.emitter.emit(events.set_picture_selection_state, { get_count: true });
    })()

    PictureGridViewModel.prototype.dispose = function () {
        console.error("Disposing CallViewModel....");
        events.emitter.removeListener(events.resize         , resizeHandler);
        events.emitter.removeListener(events.file_downloaded, onDownloaded );
        
    }

    events.emitter.emit(events.gallery_details_requested);
    self.ContentManagementActive = ko.observable();
    self.AuthorViewMode          = ko.observable();

    events.emitter.on(events.manager_code_set, function(value){ self.ContentManagementActive(!!value) });
    events.emitter.on(events.view_mode_change, function (viewMode) {

        self.AuthorViewMode(viewMode === 'Author').setViewOption('Query Results');
  
    });
    

}


module.exports = {
    viewModel: PictureGridViewModel
    , template: require('PictureGridView.html')
    , title: 'Call Page'

};